import logologin from "./logologin.svg";
import logobell from "./logobell.svg";
import logomail from "./logomail.svg";
import logoprofilenav from "./logoprofilenav.svg";
import logoedit from "./logoedit.svg";
import logopackage from "./logopackage.svg";
import logoorder from "./logoorder.svg";
import logonavbar from "./logonavbar.svg";
import lineprofilehorizontal from "./lineprofilehorizontal.svg";
import lineprofilevertical from "./lineprofilevertical.svg";
import logonoproduct from "./logonoproduct.svg";
import logomodalx from "./logomodalx.svg";
import logophoto from "./logophoto.svg";
import logocart from "./logocart.svg";
import logoproductdetail from "./logoproductdetail.svg";
import logoplus from "./logoplus.svg";
import logominus from "./logominus.svg";
import linedetailproduct from "./linedetailproduct.svg";
import logofilter from "./logofilter.svg";
import logoproducthome from "./logoproducthome.svg";
import carousel1 from "./carousel1.png";
import carousel2 from "./carousel2.png";

const assets = {
  logologin,
  logobell,
  logomail,
  logoprofilenav,
  logoedit,
  logopackage,
  logoorder,
  logonavbar,
  lineprofilehorizontal,
  lineprofilevertical,
  logonoproduct,
  logomodalx,
  logophoto,
  logocart,
  logoproductdetail,
  logoplus,
  logominus,
  linedetailproduct,
  logofilter,
  logoproducthome,
  carousel1,
  carousel2,
};

export default assets;
